module.exports = __webpack_public_path__ + "static/logo-landrover.7bd33da9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-landrover.png
// module id = 412
// module chunks = 114276838955818